// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LegendeCreneauHeure_action__1K2oh {\n  width: 15%;\n  text-align: right;\n  display: inline-block;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Legende/LegendeCreneauHeure.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":[".action {\n  width: 15%;\n  text-align: right;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action": "LegendeCreneauHeure_action__1K2oh"
};
export default ___CSS_LOADER_EXPORT___;
